import React, { useCallback, useState } from 'react';
import {
  createStyles,
  makeStyles,
  Grid,
  IconButton,
  List,
  SwipeableDrawer,
  Collapse,
} from '@material-ui/core';
import {
  Menu as MenuIcon,
  ExpandLess as ExpandLessIcon,
  ExpandMore as ExpandMoreIcon,
} from '@material-ui/icons';

import MainBarUserMenu from './MainBarUserMenu/MainBarUserMenu';
import MainBarLink from './MainBarLink';
import logo from '../../assets/img/ph/logo-text-white.svg';
import MainBarDrawerLink from './MainBarDrawerLink';
import { useGuard } from '../../hooks';
import { is, roles } from '../../utility/guard';
import { ExtendedTheme } from '../../theme';

const useStyles = makeStyles(({ palette, container }: ExtendedTheme) => createStyles({
  root: {
    maxWidth: container,
    alignItems: 'stretch',
  },
  button: {
    '&:focus': {
      outline: 'none',
    },
  },
  icon: {
    color: palette.icons.menu,
    '&:hover': {
      color: palette.navBar.hover,
    },
  },
  list: {
    width: '250px',
    paddingTop: '32px',
    paddingLeft: '8px',
  },
  logo: {
    width: '95px',
    height: '35px',
  },
  grow: {
    flexGrow: 1,
  },
  drawerPaper: {
    backgroundColor: palette.navBar.background,
    color: palette.navBar.active,
  },
  logoContainer: {
    display: 'flex',
  },
}), { name: 'MainBarContentSm' });

const MainBarContentSm = () => {
  const classes = useStyles();

  const [drawerOpened, setDrawer] = useState(false);
  const openDrawer = useCallback(() => setDrawer(true), [setDrawer]);
  const closeDrawer = useCallback(() => setDrawer(false), [setDrawer]);

  const [adminOpened, setAdmin] = useState(false);
  const toggleAdmin = useCallback((event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    setAdmin((state) => !state);
  }, [setAdmin]);

  const isAdmin = useGuard(is(roles.superAdmin));

  return (
    <>
      <Grid container className={classes.root}>
        <IconButton
          tabIndex={-1}
          edge="start"
          color="inherit"
          aria-label="open drawer"
          className={classes.button}
          onClick={openDrawer}
        >
          <MenuIcon className={classes.icon} />
        </IconButton>
        <Grid item xs className={classes.grow} />
        <Grid item className={classes.logoContainer}>
          <MainBarLink to="/dashboard">
            <img src={logo} alt="logo" className={classes.logo} />
          </MainBarLink>
        </Grid>
        <Grid item xs className={classes.grow} />
        <Grid item>
          <MainBarUserMenu compact />
        </Grid>
      </Grid>
      <SwipeableDrawer
        open={drawerOpened}
        onClose={closeDrawer}
        onOpen={openDrawer}
        style={{zIndex: 2147483101}}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div
          className={classes.list}
          role="presentation"
          onClick={closeDrawer}
          onKeyDown={closeDrawer}
        >
          <List>
            <MainBarDrawerLink label="ClipPress" to="/dashboard/projects" />
            {isAdmin && (
              <MainBarDrawerLink label="Admin" onClick={toggleAdmin} to="/dashboard/admin/*">
                {adminOpened ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </MainBarDrawerLink>
            )}
            <Collapse in={isAdmin && adminOpened} timeout="auto">
              <List component="div" disablePadding>
                <MainBarDrawerLink label="Users" to="/dashboard/admin/users" nested />
                <MainBarDrawerLink label="Organizations" to="/dashboard/admin/organizations" nested />
                <MainBarDrawerLink label="Customers" to="/dashboard/admin/customers" nested />
                <MainBarDrawerLink label="Videos" to="/dashboard/admin/videos" nested />
                <MainBarDrawerLink label="Video menu" to="/dashboard/admin/video-menus" nested />
                <MainBarDrawerLink label="Promotion codes" to="/dashboard/admin/promotion-codes" nested />
                <MainBarDrawerLink label="Orders" to="/dashboard/admin/orders" nested />
              </List>
            </Collapse>
          </List>
        </div>
      </SwipeableDrawer>
    </>
  );
};

export default MainBarContentSm;
